<template>
  <div class="popup-wrap">
    <span class="bg" @click="closePopup">></span>
    <article>
      <a class="exit" @click="closePopup">
        <span></span>
        <span></span>
      </a>
      <div class="content">
        <div v-html="data.content"></div>

        <a class="button" v-if="buttonCancel" @click="closePopup">Cancel</a>

      </div>
    </article>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  },
  data () {
    return {
      buttonCancel: true
    }
  },
  methods: {
    closePopup () {
      this.$store.commit('setPopup', {
        open: false,
        content: ''
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../sass/core/variables.scss";

.popup-wrap {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  
  width: 100%;
  height: 100%;

  .bg {
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    background: rgba(0, 0, 0, 0.4);
  }

  article {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2;

    width: 90%;
    max-width: 570px;
    margin: auto;
    padding: 20px;
    transform: translate(-50%, -50%);

    text-align: center;

    box-shadow: 0 3px 14px rgba(0, 0, 0, 0.2);
    border-radius: 2px;
    background-color: white;

    @media (min-width: $medium) {
      padding: 60px 20px 40px;
    }

    .exit {
      position: absolute;
      top: 0;
      right: 0;

      width: 40px;
      height: 40px;

      border-radius: 0 2px;
      background-color: $color-2;

      span {
        position: absolute;
        top: 18px;
        left: 7px;

        display: inline-block;
        width: 26px;
        height: 2px;

        background: white;
        transform: rotate(45deg);
      }
      span:nth-of-type(2) {
        transform: rotate(-45deg);
      }
    }

    .content {
      display: inline-block;
      vertical-align: top;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/PopupModal.vue